import { EnrollmentStatuses, StringOrNumber } from '../../../core';

export interface Enrollment {
	id: number;
	created_at: string;
	learning_path_id?: StringOrNumber;
	course_id: number;
	license_id?: StringOrNumber;
	due_date?: string;
	expires_at?: string;
	status_id?: EnrollmentStatuses;
	percentage?: StringOrNumber;
	percentage_complete?: number;
	display_name: string;
	first_name: string;
	last_name: string;
	user_id: number;
	email: string;
	username?: string;
	name: string;
	days_after_enrollment?: StringOrNumber;
	date_after_enrollment?: StringOrNumber;
	due_days_after_enrollment?: StringOrNumber;
	due_date_after_enrollment?: StringOrNumber;
	calculated_due_date?: StringOrNumber;
	calculated_expiry_date?: StringOrNumber;
	certification_id?: StringOrNumber;
	number_learning_credits: number;
	profile_image: Object;
}

export interface RequestEnrollments {
	id: number;
	status_type?: number;
	user_display_name: string;
	user_email: string;
	enroll_item_name?: string;
	status_changed_ago?: string;
	status_changed_by?: boolean;
	user_id?: number;
	course_id: number;
	lp_id?: StringOrNumber;
}

export interface PendingEnrollment {
	id: number;
	updated_at: string;
	group_id?: number;
	auth_code?: string;
	email: string;
	first_name?: string;
	last_name?: string;
	username?: string;
	display_name: string;
}

export interface EnrollmentCountBtn {
	number_enrolled?: number;
	number_of_requests?: number;
	number_pending?: number;
}

export interface SetLearnerDate {
	expires_at?: string;
	due_date?: string;
	id?: number;
}

export interface MarkCompleteData {
	enrollment_status_id?: number;
	date_completed?: string;
	percentage?: string;
	award_badges?: boolean;
	notes?: string;
}

export interface BulkActionData {
	job_id: string;
}

export enum StoredBulkActionKeys {
	ENROLLMENT_ACTION = 'enrollments_bulk_action_jobs',
	BULK_TITLE_KEY = 'enrollments_bulk_title'
}

export enum ProgressStatus {
	ALL_STATUSES = 0,
	NOT_STARTED = 1,
	IN_PROGRESS = 2,
	COMPLETED = 3,
	PASSED = 4,
	FAILED = 5,
	PENDING_REVIEW = 6
}

export enum UserType {
	ALL = 0,
	LEARNER = 1,
	ADMIN = 2,
	INSTRUCTOR = 3,
	MANAGER = 4
}

export enum UserStatus {
	ALL = null,
	LOGIN_DISABLED = 0,
	LOGIN_ENABLED = 1
}

export enum EnrollmentsSort {
	ENROLLMENT_ASC = 'created_at.desc',
	ENROLLMENT_DESC = 'created_at.asc',
	DATE_COMPLETED_ASC = 'date_completed.desc',
	DATE_COMPLETED_DESC = 'date_completed.asc',
	NAME_A_Z = 'display_name.asc',
	NAME_Z_A = 'display_name.desc'
}

export enum EnrollmentRequestSort {
	REQUEST_ASC = 'request_date.desc',
	REQUEST_DESC = 'request_date.asc',
	USER_NAME_A_Z = 'user_name.asc',
	USER_NAME_Z_A = 'user_name.desc',
	COURSE_NAME_ASC = 'course_name.desc',
	COURSE_NAME_DESC = 'course_name.asc'
}

export enum PendingEnrollmentSort {
	PENDING_ASC = 'created_at.desc',
	PENDING_DESC = 'created_at.asc',
	DATE_ASC = 'date_completed.desc',
	DATE_DESC = 'date_completed.asc',
	USER_NAME_A_Z = 'display_name.asc',
	USER_NAME_Z_A = 'display_name.desc'
}

export enum JobType {
	UNENROLL = 'UNENROLL',
	SET_COMPLETE = 'MARKCOMPLETE'
}

export const JobTitleContent = {
	[JobType.UNENROLL]: {
		title: 'lup.enrollments.bulk_action.unenrollment_in_progress'
	},
	[JobType.SET_COMPLETE]: {
		title: 'lup.enrollments.bulk_action.set_complete'
	}
};

export const thresholdForErrors = 10;

export interface BulkActionProgressData {
	id: number;
	created_by_pm_id: number;
	domain: string;
	has_errors?: boolean;
	job_data?: BulkActionJobData[];
	operation: string;
	status_id: number;
	work_done: number;
	work_to_do: number;
}

export interface BulkActionJobData {
	error_data: string;
	error_key: string;
}

export enum ListType {
	ENROLLED,
	PENDING,
	REQUESTED
}
